import React from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import Link from 'gatsby-link'
import Button from '@material-ui/core/Button'
import withStyles from '@material-ui/core/styles/withStyles'
import GatsbyImage from 'gatsby-image'
import Grid from '@material-ui/core/Grid'
import Phaser from 'components/Phaser'
import { ArticleMeta } from 'components/Meta'
import Mentions from 'components/Mentions'
import { pageStyle } from 'config/theme'

const styles = (theme) => ({
  container: {
    ...pageStyle(theme),
    width: 700,
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  body: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.8em',
    },
  },
})

const WorkoutTemplate = (props) => {
  const { classes, theme, data, pathContext } = props
  const {
    markdownRemark: workout,
    imageSharp: { sizes },
    file,
  } = data
  const { articleBody } = pathContext

  const datePublished = new Date(file.birthTime).toISOString()
  const dateModified = file.modifiedTime

  return (
    <Grid
      id="workoutPage"
      classes={{ container: classes.container }}
      justify="center"
      spacing={24}
      container
    >
      <ArticleMeta
        title={workout.frontmatter.title}
        shortDescription={workout.frontmatter.shortDescription}
        thumbnail={workout.frontmatter.thumbnail}
        genre="health-fitness"
        tags={workout.frontmatter.tags}
        wordCount={workout.wordCount.words}
        datePublished={datePublished}
        dateModified={dateModified}
        articleBody={articleBody}
        excerpt={workout.excerpt}
        path={workout.fields.slug}
      />
      <Grid xs={12} classes={{ item: classes.body }} item>
        <Phaser fontSize="2.2em" label={workout.frontmatter.title} />
        <GatsbyImage
          sizes={sizes}
          title={workout.frontmatter.title}
          alt={workout.frontmatter.title}
        />
        <div
          className="markdown"
          dangerouslySetInnerHTML={{ __html: workout.html }}
        />
        <div style={{ paddingTop: 20 }}>
          <Mentions mentions={workout.frontmatter.mentions} />
        </div>
        <div
          style={{
            textAlign: 'center',
            padding: 30,
          }}
        >
          <Link to="/weight-loss-workouts">
            <Button variant="raised" size="small" color="primary">
              Back to workouts
            </Button>
          </Link>
        </div>
      </Grid>
      <style>{`
        div.markdown img {
          width: 100%;
          height: 350px;
          object-fit: cover;
        }
        div.markdown {
          color: ${theme.palette.text.soft};
        }
        table {
          border: 1px solid ${theme.palette.primary.main};
        }
        table th {
          background: ${theme.palette.primary.main};
          color: #fff;
          padding: 10px;
        }
        table td {
          border: 1px solid ${theme.palette.borders.cloud};
        }
        h1, h2, h3, h4, h5, h6 {
          line-height: 1em;
        }
        h1 {
          padding: 20px 0;
        }
        @media (max-width: 600px) {
          div.markdown h1, h2, h3 {
            font-size: 1.4em;
          }
          div.markdown img {
            height: 100%;
          }
        }
      `}</style>
    </Grid>
  )
} //

WorkoutTemplate.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object,
  pathContext: PropTypes.shape({
    articleBody: PropTypes.string.isRequired,
  }),
}

// eslint-disable-next-line
export const query = graphql`
  query WorkoutTemplateQuery(
    $path: String!
    $fileAbsolutePath: String!
    $idRegex: String!
  ) {
    markdownRemark(fields: { slug: { eq: $path } }) {
      html
      excerpt(pruneLength: 300)
      timeToRead
      wordCount {
        words
      }
      fields {
        slug
      }
      frontmatter {
        title
        shortDescription
        tags
        mentions
      }
    }
    file(absolutePath: { eq: $fileAbsolutePath }) {
      modifiedTime
      birthTime
    }
    imageSharp(sizes: { originalName: { regex: $idRegex } }) {
      sizes(maxWidth: 950, traceSVG: { color: "#285978" }) {
        originalName
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
  }
`

// prettier-ignore
export default compose(
  withStyles(styles, { withTheme: true }),
)(WorkoutTemplate)



// WEBPACK FOOTER //
// ./src/templates/workout.js